import { useMemo } from 'react';

export const usePayBenchmarkingCanApplyFilters = ({
  selectedBenchmark,
  selectedCurrency,
  selectedDepartment,
  selectedEducationLabel,
  selectedExperience,
  selectedLevel,
  selectedLocation,
  selectedRole,
}: {
  selectedBenchmark: string | null;
  selectedCurrency: string | null;
  selectedDepartment: string | null;
  selectedEducationLabel: string | null;
  selectedExperience: string | null;
  selectedLevel: string | null;
  selectedLocation: string | null;
  selectedRole: string | null;
}) => {
  return useMemo(() => {
    return (
      selectedDepartment !== null &&
      selectedBenchmark !== null &&
      selectedRole !== null &&
      selectedLevel !== null &&
      selectedLocation !== null &&
      selectedExperience !== null &&
      selectedEducationLabel !== null &&
      selectedCurrency !== null
    );
  }, [
    selectedBenchmark,
    selectedCurrency,
    selectedDepartment,
    selectedEducationLabel,
    selectedExperience,
    selectedLevel,
    selectedLocation,
    selectedRole,
  ]);
};
